import React from 'react';

import {Box, Stack, Typography} from '@mui/material';
import Icon from 'presentation/icons';

import {translations} from 'presentation/translations-new';
import {formatText, getUserInfoFromToken} from 'presentation/utils';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {BeneficiaryCardProps} from './types';

const {beneficiaryPlan} = translations['pt-br'].commons;
const {
	cardData: {cardCode, ansPlanRegister},
} = translations['pt-br'].privateFlow.healthCard;

function BeneficiaryCard({shouldShowAnsPlanRegister = true}: BeneficiaryCardProps) {
	const {
		beneficiary: {nmPlano, nmSocialUsuarioC, nmUsuarioC, nuRegistroPlano},
	} = useAccountDataStore(state => state.accountData);

	const beneficiaryCardPlanData = {
		planName: nmPlano,
		userName: formatText(nmSocialUsuarioC || nmUsuarioC),
	};

	const {cdUsuario} = getUserInfoFromToken();

	return (
		<Stack bgcolor={'white'} p={2} borderRadius={1} gap={1}>
			<Typography variant="h6" fontSize="0.875rem" color="text.secondary">
				{beneficiaryPlan}
			</Typography>
			<Box display="flex" alignItems="center" gap={1}>
				<Icon name="account-circle-filled" size={20} />
				<Typography variant="body1" color="text.primary">
					{beneficiaryCardPlanData.userName}
				</Typography>
			</Box>
			<Box display="flex" gap={1}>
				<Icon name="hapvida-logo" size={20} />
				<Stack>
					<Typography variant="body1" color="text.primary">
						{beneficiaryCardPlanData.planName}
					</Typography>

					<Typography variant="body2" color="text.secondary">
						{cardCode}: {cdUsuario}
					</Typography>
					{shouldShowAnsPlanRegister ? (
						<Typography variant="body2" color="text.secondary">
							{ansPlanRegister}: {nuRegistroPlano}
						</Typography>
					) : null}
				</Stack>
			</Box>
		</Stack>
	);
}

export {BeneficiaryCard};
